import { Outlet } from 'react-router-dom';
import { BrandAuthProvider } from '@/hooks/useBrandAuth';

/**
 * Layout wrapper for all brand portal routes.
 * Provides shared auth context to prevent multiple validate API calls.
 */
export function BrandLayout() {
  return (
    <BrandAuthProvider>
      <Outlet />
    </BrandAuthProvider>
  );
}
